import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';

const APP_NAME = 'Conntour';

type TitleKey = keyof typeof PAGE_TITLE_KEYS;

const PAGE_TITLE_KEYS = {
    home: 'pageTitle.home',
    sources: 'pageTitle.sources',
    source: 'pageTitle.source',
    events: 'pageTitle.events',
    event: 'pageTitle.event',
    alertRules: 'pageTitle.alertRules',
    alertRule: 'pageTitle.alertRule',
    alertRuleCreate: 'pageTitle.alertRuleCreate',
    alertRuleEdit: 'pageTitle.alertRuleEdit',
    alerts: 'pageTitle.alerts',
    databaseEvents: 'pageTitle.databaseEvents',
    cameras: 'pageTitle.cameras',
    explore: 'pageTitle.explore',
    settings: 'pageTitle.settings',
    settingsMember: 'pageTitle.settingsMember',
    signIn: 'pageTitle.signIn',
    notFound: 'pageTitle.notFound',
    vehicle: 'pageTitle.vehicle',
    reports: 'pageTitle.reports',
    setupHdmi: 'pageTitle.setupHdmi',
    person: 'pageTitle.person',
} as const;

export function useDocumentTitle(
    titleKey: TitleKey,
    dynamicPart?: string,
): void {
    const { t } = useTranslation(I18nNamespace.COMMON);

    useEffect(() => {
        const pageTitle = t(PAGE_TITLE_KEYS[titleKey]);
        const fullTitle = dynamicPart
            ? `${APP_NAME} | ${pageTitle} — ${dynamicPart}`
            : `${APP_NAME} | ${pageTitle}`;

        document.title = fullTitle;

        return () => {
            document.title = APP_NAME;
        };
    }, [t, titleKey, dynamicPart]);
}
